import { InfoOutlined } from '@mui/icons-material';
import EditIcon from '@mui/icons-material/Edit';
import { Box, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip } from '@mui/material';
import _ from 'lodash';
import React from 'react';
import { EmployeeTimeOff, EmployeeTimeOffMode } from '../../types/EmployeeTimeOff';
import { AVAILABILITY_STATUS_CONFIG, getAvailabilityStatus } from '../../utility/availability';
import { humanizeDate } from '../../utility/dateUtils';
import { WEEKDAYS } from '../common/employees/TimeOffModal';

interface Props {
  rows: EmployeeTimeOff[];
  onEdit: (uuid: string, mode: EmployeeTimeOffMode) => void;
  onApproveToggle: (employeeTimeOff: EmployeeTimeOff) => void;
  canManageAll: boolean;
  canManageOwnTimeOff: boolean;
}

const weekdayShortLabel = (weekday: number): string => _.find(WEEKDAYS, { value: weekday })?.short ?? '';

export default function EmployeeAvailabilityTable({ rows, onEdit, onApproveToggle, canManageAll, canManageOwnTimeOff }: Props) {
  return (
    <TableContainer>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell>TYPE</TableCell>
            <TableCell>START DATE</TableCell>
            <TableCell>END DATE</TableCell>
            <TableCell>STATUS</TableCell>

            {/* LATER TODO: Request Off Logic */}
            {/* {canManageAll && <TableCell>APPROVAL</TableCell>} */}

            <TableCell>DAYS OF WEEK</TableCell>

            {(canManageAll || canManageOwnTimeOff) && <TableCell>ACTIONS</TableCell>}
          </TableRow>
        </TableHead>

        <TableBody>
          {_.map(rows, (item) => {
            const status = getAvailabilityStatus(item.approved);
            const { label, color } = AVAILABILITY_STATUS_CONFIG[status];
            // Employees can still edit/delete their own Time Off entries.
            // Schedules are admin-only.
            const canManageRecord = canManageAll || (canManageOwnTimeOff && item.mode === EmployeeTimeOffMode.FULL);

            return (
              <TableRow key={item.uuid}>
                <TableCell>{item.mode === EmployeeTimeOffMode.WEEKLY ? 'Schedule' : 'Time Off'}</TableCell>

                <TableCell>{humanizeDate(item.start_date)}</TableCell>

                <TableCell>{humanizeDate(item.end_date)}</TableCell>

                <TableCell>
                  <Box
                    sx={{
                      fontWeight: 600,
                      color,
                    }}
                  >
                    {label}
                  </Box>
                </TableCell>

                {/* LATER TODO: Request Off Logic */}
                {/* {canManageAll && (
                  <TableCell>
                    <Button onClick={() => onApproveToggle(item)} variant="outlined" size="small">
                      {item.approved ? 'Unapprove' : 'Approve'}
                    </Button>
                  </TableCell>
                )} */}

                <TableCell>{item.mode === EmployeeTimeOffMode.WEEKLY ? _.map(_.sortBy(item.details || []), weekdayShortLabel).join(', ') : '—'}</TableCell>

                {(canManageAll || canManageOwnTimeOff) && (
                  <TableCell>
                    {canManageRecord ? (
                      <IconButton size="small" onClick={() => onEdit(item.uuid, item.mode)}>
                        <EditIcon />
                      </IconButton>
                    ) : (
                      <Tooltip title="Schedule can only be changed by a manager" arrow>
                        <IconButton size="small">
                          <InfoOutlined />
                        </IconButton>
                      </Tooltip>
                    )}
                  </TableCell>
                )}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
